export default __webpack_public_path__ + "2b4d81385b2809fe2bcf3d0061a89adb.jpg";